import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";
import { api } from "../../../../../../utility/AxiosInceptor";

const DeleteDialog = React.memo(
  ({
    visible,
    setVisible,
    delteBillingLoader,
    setDeleteBillingLoader,
    toast,
    setRowData,
    rowData,
    setRefresh,
  }) => {
    return (
      <Dialog
        headerClassName="dialogheader"
        closable={false}
        visible={visible}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
        className="delete-dialog"
      >
        <div className="flex flex-column">
          <div className="datadelete">
            <h1>Confirm Deletion</h1>
            <p>
              {" "}
              Are you sure you want to delete this plan? This action cannot be
              undone. Proceed with caution.
            </p>{" "}
          </div>
          <div className="deletedialogbtn">
            <Button
              className="backbtn"
              label="Cancel"
              onClick={() => setVisible(false)}
              style={{ width: "16rem", height: "5rem" }}
            />
            <Button
              label="Delete"
              className="nextbtn"
              loading={delteBillingLoader}
              disabled={delteBillingLoader}
              onClick={() => {
                setDeleteBillingLoader(true);

                api
                  .delete(
                    `/api/web/billing/deletebillconfig?billId=${rowData._id}`,
                  )
                  .then(() => {
                    toast.success("Plan Deleted Successfully ");
                    setRowData();
                    setRefresh((prev) => !prev);
                    setDeleteBillingLoader(false);
                    setTimeout(() => {
                      setVisible(false);
                    }, 500);
                  })
                  .catch((err) => {
                    toast.error("Plan Deletion Failed");
                    setDeleteBillingLoader(false);
                  });
              }}
              style={{ width: "16rem", height: "5rem" }}
            />
          </div>
        </div>
      </Dialog>
    );
  },
);

export default DeleteDialog;
